import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { consentDecisionMade, setAnalyticsConsent } from "@/lib/analytics";
import { loadPlausibleIfConsented } from "@/lib/analytics-plausible";
import { useTranslation } from "react-i18next";
import { ConsentPreferencesDialog } from "@/components/consent/PreferencesDialog";

export function CookieConsent() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [prefsOpen, setPrefsOpen] = useState(false);

  useEffect(() => {
    if (!consentDecisionMade()) setShow(true);
    const onOpenPrefs = () => setPrefsOpen(true);
    document.addEventListener("bp:open-cookie-prefs", onOpenPrefs);
    return () => document.removeEventListener("bp:open-cookie-prefs", onOpenPrefs);
  }, []);

  const decide = (granted: boolean) => {
    setAnalyticsConsent(granted);
    if (granted) loadPlausibleIfConsented();
    setShow(false);
  };

  return (
    <>
      {show && (
        <div
          role="dialog"
          aria-live="polite"
          aria-label={t("consent.title")}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-50 rounded-lg border border-border bg-card text-card-foreground shadow-lg p-4 space-y-3"
        >
          <p className="text-sm">{t("consent.message")}</p>
          <div className="flex flex-wrap items-center justify-end gap-2">
            <button
              type="button"
              onClick={() => {
                setShow(false);
                setPrefsOpen(true);
              }}
              className="text-xs text-muted-foreground underline-offset-2 hover:text-foreground hover:underline"
            >
              {t("consent.manage")}
            </button>
            <Button size="sm" variant="outline" onClick={() => decide(false)}>
              {t("consent.decline")}
            </Button>
            <Button size="sm" onClick={() => decide(true)}>
              {t("consent.accept")}
            </Button>
          </div>
        </div>
      )}
      <ConsentPreferencesDialog open={prefsOpen} onOpenChange={setPrefsOpen} />
    </>
  );
}
